import { render, staticRenderFns } from "./AddIntroductionArticle.vue?vue&type=template&id=2a6f7876&scoped=true&"
import script from "./AddIntroductionArticle.vue?vue&type=script&lang=js&"
export * from "./AddIntroductionArticle.vue?vue&type=script&lang=js&"
import style0 from "./AddIntroductionArticle.vue?vue&type=style&index=0&id=2a6f7876&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f7876",
  null
  
)

export default component.exports